import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getTableMessage, getNumTableMessages, gameLobbyMessageEnum } from '../room/roomSlice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import classNames from "classnames";
import ScrollToBottom from '../../components/ScrollToBottom';
import { ChatSubmit } from '../../components/ChatSubmit';

import './LobbyChat.css';

const Message = (props) => {
  const { t } = useTranslation();
  const args = props.args ?? {};

  switch (props.type) {
    case gameLobbyMessageEnum.MESSAGE: {
      return (
        <Trans t={t} i18nKey="GAME_LOBBY_MESSAGE.MESSAGE">
          <span className="player">{{player: args.name}}</span> {{data: args.data}}
        </Trans>
      );
    }
    case gameLobbyMessageEnum.PLAYER_JOIN: {
      return (
        <Trans t={t} i18nKey="GAME_LOBBY_MESSAGE.PLAYER_JOIN">
          <span className="player">{{player: args.name}}</span> har anslutit.
        </Trans>
      );
    }
    case gameLobbyMessageEnum.PLAYER_LEAVE: {
      return (
        <Trans t={t} i18nKey="GAME_LOBBY_MESSAGE.PLAYER_LEAVE">
          <span className="player">{{player: args.name}}</span> lämnade spelet.
        </Trans>
      );
    }
    default: {
      throw Error('Unknown lobbyMessageEnum '+ props.type);
    }
  }
}

const MessageWrapper = (props) => {
  const msg = useSelector(state => getTableMessage(state, props.tableID, props.id), shallowEqual);
  const cls = classNames({
    'auto': msg.type !== gameLobbyMessageEnum.MESSAGE,
    'message': msg.type === gameLobbyMessageEnum.MESSAGE,
  })
  return (
    <div className={cls}>{msg.type !== gameLobbyMessageEnum.MESSAGE ? "» " : ""}<Message type={msg.type} args={msg.args}/></div>
  );
}

const Messages = (props) => {
  const num = useSelector(state => getNumTableMessages(state, props.tableID));
  return (
    <ScrollToBottom className="messages box">
      {[...Array(num).keys()].map(id => (
        <MessageWrapper key={id} id={id} tableID={props.tableID}/>
      ))}
    </ScrollToBottom>
  );
};

export const LobbyChat = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <h2>{t("CHAT")}</h2>
      <Messages tableID={props.tableID}/>
      <ChatSubmit onSubmit={msg => dispatch({ type: 'action/message', payload: {dest: 'GAME', data: msg} })} />
    </>
  );
};